
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

export type Variant = 'circle' | 'square'

@Observer
@Component({
  components: {}
})
export default class SkeletonItem extends Vue {
  @Prop({ required: true }) variant: 'circle' | 'square'
  @Prop({ default: 40 }) width: number
  @Prop({ default: 40 }) height: number
  @Prop({ default: 0 }) radius: number

  get style() {
    const styles: Array<string> = []

    styles.push(`width: ${this.$px2rem(this.width)}`)
    styles.push(`height: ${this.$px2rem(this.height)}`)
    styles.push(`border-radius: ${this.variant === 'circle' ? '100%' : this.$px2rem(this.radius)}`)

    return styles.join(';')
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
